import {Utilities} from '@shared/utilities/utilities.model';

export class VehicleEquipmentModel {
	booklet: boolean;
	payslip: boolean;
	registrationCertificate: boolean;
	marching: boolean;
	doubleKeys: boolean;
	rolling: boolean;
	fire: boolean;
	keys: boolean;
	frontPlate: boolean;
	rearPlate: boolean;


	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.booklet = model.booklet;
			this.payslip = model.payslip;
			this.registrationCertificate = model.registration_certificate;
			this.marching = model.marching;
			this.doubleKeys = model.double_keys;
			this.rolling = model.rolling;
			this.fire = model.fire;
			this.keys = model.keys;
			this.frontPlate = model.front_plate;
			this.rearPlate = model.rear_plate;
		} else {
			this.booklet = false;
			this.payslip = false;
			this.registrationCertificate = false;
			this.marching = false;
			this.doubleKeys = false;
			this.rolling = false;
			this.fire = false;
			this.keys = false;
			this.frontPlate = false;
			this.rearPlate = false;
		}
	}
}

export class VehicleEquipmentRequestModel {
	booklet: boolean;
	payslip: boolean;
	registration_certificate: boolean;
	rear_plate: boolean;
	front_plate: boolean;
	fire: boolean;
	double_keys: boolean;
	keys: boolean;
	marching: boolean;
	rolling: boolean;


	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.booklet = model.booklet;
			this.payslip = model.payslip;
			this.registration_certificate = model.registrationCertificate;
			this.marching = model.marching;
			this.double_keys = model.doubleKeys;
			this.rolling = model.rolling;
			this.fire = model.fire;
			this.keys = model.keys;
			this.front_plate = model.frontPlate;
			this.rear_plate = model.rearPlate;
		} else {
			this.booklet = false;
			this.payslip = false;
			this.registration_certificate = false;
			this.marching = false;
			this.double_keys = false;
			this.rolling = false;
			this.fire = false;
			this.keys = false;
			this.front_plate = false;
			this.rear_plate = false;
		}
	}
}
